import React from "react";
import { Row, Col } from "react-bootstrap";
import "./Category.css";
import { NavLink } from "react-router-dom";

const Category = ({ data }) => {



  return (
    <>
    <div className="technology-banner-section pt-5 pb-5">
      <div className="container">
        <Row className="justify-content-center ">
          {data.map((item, index) => {
            return (
              <Col key={index} md={2} className="justify-content-center d-flex ">
                <NavLink to={item.href} className="w-100 text-center category-container text-decoration-none">
                  <img src={item.image} alt={item.title} className="mb-4" />
                  <h4><b>{item.title}</b></h4>
                </NavLink>
              </Col>
            );
          })}
        </Row>
      </div>
      </div>
      {/* {selectedCategory && renderData()} */}
    </>
  );
};

export default Category;
